import { Box } from '@chakra-ui/react'
import type { ReactElement, RefObject } from 'react'
import { useMemo, useRef } from 'react'

interface Props {
  shadowRef: RefObject<HTMLDivElement>
}

const StickyShadow = ({ shadowRef }: Props): ReactElement => {
  const boxRef = useRef<HTMLDivElement>(null)

  const topOffset = useMemo<number>(() => {
    const rect = shadowRef.current?.getBoundingClientRect()
    const bottomCoordinate = rect?.bottom ?? 0
    const boxHeight = boxRef.current?.offsetHeight ?? 0
    return bottomCoordinate - boxHeight
  }, [shadowRef.current, boxRef.current])

  return (
    <>
      <Box
        ref={boxRef}
        position="sticky"
        top={topOffset}
        boxShadow="0px 2px 5px rgba(0,0,0, 16%)"
        zIndex={8}
        marginTop="calc(-1 * 1.5rem)"
      >
        &nbsp;
      </Box>
      <Box
        position="sticky"
        top={topOffset}
        background="linear-gradient(white 75%, transparent 100%)"
        zIndex={9}
        marginTop="calc(-0.5 * 1.5rem)"
      >
        &nbsp;
      </Box>
    </>
  )
}

export default StickyShadow
